/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FormSeen,
    FormSeenFromJSON,
    FormSeenFromJSONTyped,
    FormSeenToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface FormSeenResponse
 */
export interface FormSeenResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof FormSeenResponse
     */
    msg: string;
    /**
     * 
     * @type {FormSeen}
     * @memberof FormSeenResponse
     */
    entry: FormSeen;
}

export function FormSeenResponseFromJSON(json: any): FormSeenResponse {
    return FormSeenResponseFromJSONTyped(json, false);
}

export function FormSeenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormSeenResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': FormSeenFromJSON(json['entry']),
    };
}

export function FormSeenResponseToJSON(value?: FormSeenResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': FormSeenToJSON(value.entry),
    };
}


